import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import {
    Breadcrumbs as BreadcrumbComponent,
    BreadcrumbItem,
    Section,
} from 'wanderu-components';

import styles from './Breadcrumbs.scss';

function Breadcrumbs({ data }) {
    return (
        <Section className={styles.container}>
            <BreadcrumbComponent>
                {data.transMode && data.transMode.name && (
                    <BreadcrumbItem>
                        <A
                            className={styles.link}
                            href={data.transMode.url}
                        >
                            {data.transMode.name}
                        </A>
                    </BreadcrumbItem>
                )}
                {data.toCountry && data.toCountry.name && (
                    <BreadcrumbItem>
                        <A
                            className={styles.link}
                            href={data.toCountry.url}
                        >
                            {data.toCountry.name}
                        </A>
                    </BreadcrumbItem>
                )}
                {data.toState && data.toState.name && (
                    <BreadcrumbItem>
                        <A
                            className={styles.link}
                            href={data.toState.url}
                        >
                            {data.toState.name}
                        </A>
                    </BreadcrumbItem>
                )}
                {data.toCity && data.toCity.name && (
                    <BreadcrumbItem>
                        <A
                            className={styles.link}
                            href={data.toCity.url}
                        >
                            {data.toCity.name}
                        </A>
                    </BreadcrumbItem>
                )}
                <BreadcrumbItem isActive>
                    {data.activeIndex.name}
                </BreadcrumbItem>
            </BreadcrumbComponent>
        </Section>
    );
}

Breadcrumbs.propTypes = {
    data: PropTypes.shape({
        transMode: PropTypes.shape({
            name: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        }).isRequired,
        toCountry: PropTypes.shape({
            code: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        }),
        toState: PropTypes.shape({
            code: PropTypes.string,
            name: PropTypes.string,
            url: PropTypes.string,
        }),
        toCity: PropTypes.shape({
            name: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        }),
        activeIndex: PropTypes.shape({
            name: PropTypes.string.isRequired,
        }).isRequired,
    }),
};

export { Breadcrumbs };
export default Breadcrumbs;
